import {atomWithReset} from 'jotai/utils'

export const SUBQL_ENDPOINT = process.env.NEXT_PUBLIC_SUBQL_ENDPOINT ||
  'https://api-test.phala.world/query'

export const subqlEndpointAtom = atomWithReset<string>(SUBQL_ENDPOINT)
